import type { ActivityV2 } from '~/components/template/EventTimelineV2/types';
import type { TaskListType } from '../../types';

const inListType = (
  task: ActivityV2,
  selectedListType: TaskListType,
): boolean => 'status' in task && selectedListType === task.status;

export default inListType;
